export const getCarouselSettings = (itemLength: number) => {
    let desktop = { slidePerView: 1, numberOfRows: 1, aspectRatio: '' };
    let tablet = { slidePerView: 1, numberOfRows: 1, aspectRatio: '' };
    let mobile = { slidePerView: 1, numberOfRows: 1 };

    switch (true) {
        case itemLength > 6:
            desktop = { slidePerView: 6, numberOfRows: 1, aspectRatio: '4/3' };
            tablet = { slidePerView: 4, numberOfRows: 1, aspectRatio: '1/1' };
            mobile = { slidePerView: 2.3, numberOfRows: 1 };
            break;
        case itemLength === 6:
            desktop = { slidePerView: 6, numberOfRows: 1, aspectRatio: '4/3' };
            tablet = { slidePerView: 3, numberOfRows: 2, aspectRatio: '1/1' };
            mobile = { slidePerView: 2, numberOfRows: 3 };
            break;
        case itemLength === 5:
            desktop = { slidePerView: 5, numberOfRows: 1, aspectRatio: '3/2' };
            tablet = { slidePerView: 4, numberOfRows: 1, aspectRatio: '1/1' };
            mobile = { slidePerView: 2.3, numberOfRows: 1 };
            break;
        case itemLength === 4:
            desktop = { slidePerView: 4, numberOfRows: 1, aspectRatio: '4/3' };
            tablet = { slidePerView: 4, numberOfRows: 1, aspectRatio: '1/1' };
            mobile = { slidePerView: 2, numberOfRows: 2 };
            break;
        case itemLength === 3:
            desktop = { slidePerView: 3, numberOfRows: 1, aspectRatio: '4/3' };
            tablet = { slidePerView: 3, numberOfRows: 1, aspectRatio: '3/2' };
            mobile = { slidePerView: 2.3, numberOfRows: 1 };
            break;
        default:
            desktop = { slidePerView: itemLength, numberOfRows: 1, aspectRatio: '4/3' };
            tablet = { slidePerView: itemLength, numberOfRows: 1, aspectRatio: '1/1' };
            mobile = { slidePerView: itemLength, numberOfRows: 1 };
    }

    return { desktop, tablet, mobile };
};
